import i18n from 'i18next'
import { useSyncExternalStore } from 'react'

const subscribe = (onChange: () => void) => {
  i18n.on('languageChanged', onChange)
  return () => i18n.off('languageChanged', onChange)
}

const getSnapshot = () => i18n.resolvedLanguage

/**
 * The language `formatPrice` / `formatPercentage` / `formatCurrency` format with (QA-364). The
 * formatters are plain functions reading the `i18next` singleton, so a `useMemo` that calls them
 * must list this value in its deps — the app switches language in place (TopBar dropdown,
 * `applyLanguageFromUserMe`, embed `?lang` self-heal) and a memo keyed on data alone would keep
 * the old separators and currency position. Subscribes to `i18next` directly rather than through
 * `useTranslation`, so tests that mock `react-i18next` to `{ t }` keep working.
 */
export const useFormatterLanguage = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
